import { gql } from '@apollo/client';

export const AscGroupingTicketOrCollectionFragment = gql`
  fragment AscGroupingTicketOrCollection on AscGroupingTicketOrCollection {
    id
    identifier
    name
    kind
    ticketType
    count
    ascProjectId
    fiscalYearId
    periodName
    matchingReasoning
    isMatchedInLatestSync
  }
`;
